export default "__VITE_ASSET__CMkRHW8l__"